import { noop } from 'lodash';
import type { FunctionComponent } from 'react';

import type { JobProfileComponent } from '~/shared/data-contract/job-profile';

import { ContentSections } from '../components/Common';
import { CategoryList } from '../job-profile-section/skills/CategoryList';
import { useCompetenciesWithSkillsAndDiff } from './comparison-utils';

export const SkillsComparisonSection: FunctionComponent<{
    readonly leftProfile: JobProfileComponent;
    readonly rightProfile: JobProfileComponent;
    readonly showProficiency: boolean;
}> = ({ leftProfile, rightProfile, showProficiency }) => {
    const oldCompetenciesWithSkills = useCompetenciesWithSkillsAndDiff(leftProfile, rightProfile, 'removed', {
        compareLevels: showProficiency,
    });
    const currentCompetenciesWithSkills = useCompetenciesWithSkillsAndDiff(rightProfile, leftProfile, 'added', {
        compareLevels: showProficiency,
    });

    return (
        <ContentSections columns="two" style={{ gap: 32 }}>
            <CategoryList
                commentable={false}
                competenciesWithSkills={oldCompetenciesWithSkills}
                handleOnDragEnd={noop}
                isInEditMode={false}
                onChangeProficiencyLevel={noop}
                onOpenSkillDetails={noop}
                onRemoveCompetency={noop}
                onRemoveSkill={noop}
                showProficiency={showProficiency}
            />
            <CategoryList
                commentable={false}
                competenciesWithSkills={currentCompetenciesWithSkills}
                handleOnDragEnd={noop}
                isInEditMode={false}
                onChangeProficiencyLevel={noop}
                onOpenSkillDetails={noop}
                onRemoveCompetency={noop}
                onRemoveSkill={noop}
                showProficiency={showProficiency}
            />
        </ContentSections>
    );
};
